import React, { FC } from 'react'
import { BioByline } from '../style'

//* components
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type Props = {
  cn: any
  bio: any
  href: string
}

export const ByLine: FC<Props> = ({ cn, bio, href }) => (
  <BioByline {...cn} data-cy="bioByline">
    {bio.headshot.url && (
      <WrapperImage
        src={bio.headshot.url}
        alt={bio.headshot.alt}
        width={80}
        height={80}
        threshold={650}
      />
    )}

    {bio.firstName && bio.lastName && (
      <>
        <Typography type="body" className="font__inter">
          by
        </Typography>

        <a href={href}>
          {bio.firstName} {bio.lastName}
        </a>
      </>
    )}
  </BioByline>
)
